import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TextOrLine = styled.span`
  padding: 0 1.5rem;
`;
const ContainerOrLine = styled.div`
  clear: both;
  font-size: 16px;
  font-weight: 400;
  margin: 1rem 0;
  text-align: center;
  display: flex;
  width: 100%;
  align-items: center;
  width: ${props => props.width};
`;
const HorizontalSeparator = styled.hr`
  width: 100%;
  border-top: 1px solid #777;
`;

const OrLineSeparator = ({ props, children }) => (
  <ContainerOrLine {...props}>
    <HorizontalSeparator />
    <TextOrLine>{children || 'OR'}</TextOrLine>
    <HorizontalSeparator />
  </ContainerOrLine>
);

OrLineSeparator.propTypes = {
  children: PropTypes.node,
  props: PropTypes.shape({})
};

OrLineSeparator.defaultProps = {
  children: null,
  props: {}
};

export default OrLineSeparator;
